<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Modifier les informations de la facture</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div v-if="view=='company'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Informations générales</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Raison sociale</label>
                                <input type="text" v-model="sl.company" placeholder="Raison sociale" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Rue principale</label>
                                <input type="text" v-model="sl.address1" placeholder="Adresse" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Etage, ...</label>
                                <input type="text" v-model="sl.address2" placeholder="Adresse 2" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Adresse complémentaire</label>
                                <input type="text" v-model="sl.address3" placeholder="Adresse 3" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Code postal</label>
                                <input type="text" v-model="sl.zipcode" placeholder="Code postal" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Ville</label>
                                <input type="text" v-model="sl.city" placeholder="Ville" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Pays</label>
                                <input type="text" v-model="sl.country" placeholder="Pays" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Téléphone</label>
                                <input type="text" v-model="sl.phone" placeholder="Téléphone" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Courriel</label>
                                <input type="text" v-model="sl.email" placeholder="Courriel" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Site web</label>
                                <input type="text" v-model="sl.website" placeholder="Site web" :disabled="is_disabled">
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='customer'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Adresse de facturation</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Raison sociale</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingcompany" placeholder="Raison sociale" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Rue principale</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingaddress1" placeholder="Adresse" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Etage, ...</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingaddress2" placeholder="Adresse 2" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Adresse complémentaire</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingaddress3" placeholder="Adresse 3" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Code postal</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingzipcode" placeholder="Code postal" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Ville</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingcity" placeholder="Ville" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Pays</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingcountry" placeholder="Pays" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Téléphone</label>
                                <input @change="set_copy_auto" type="text" v-model="sl.cust_billingphone" placeholder="Téléphone" :disabled="is_disabled">
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='customer'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Informations administratives et comptables</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Courriel</label>
                                <input type="text" v-model="sl.cust_email" placeholder="Courriel" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Numéro de compte comptable</label>
                                <input type="text" v-model="sl.cust_account_number" placeholder="Compte comptable" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>SIRET</label>
                                <input type="text" v-model="sl.cust_siret" placeholder="SIRET" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Numéro de TVA Intracommunautaire</label>
                                <input type="text" v-model="sl.cust_vat_identication" placeholder="Numéro de TVA Intracommunautaire" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Code APE</label>
                                <input type="text" v-model="sl.cust_ape_code" placeholder="Code APE" :disabled="is_disabled">
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='customer'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Adresse de livraison</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Raison sociale</label>
                                <input type="text" v-model="sl.cust_deliverycompany" placeholder="Raison sociale" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Rue principale</label>
                                <input type="text" v-model="sl.cust_deliveryaddress1" placeholder="Adresse" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Etage, ...</label>
                                <input type="text" v-model="sl.cust_deliveryaddress2" placeholder="Adresse 2" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Adresse complémentaire</label>
                                <input type="text" v-model="sl.cust_deliveryaddress3" placeholder="Adresse 3" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Code postal</label>
                                <input type="text" v-model="sl.cust_deliveryzipcode" placeholder="Code postal" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Ville</label>
                                <input type="text" v-model="sl.cust_deliverycity" placeholder="Ville" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Pays</label>
                                <input type="text" v-model="sl.cust_deliverycountry" placeholder="Pays" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Téléphone</label>
                                <input type="text" v-model="sl.cust_deliveryphone" placeholder="Téléphone" :disabled="is_disabled">
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='document'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Document</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Numéro</label>
                                <input type="text" v-model="sl.invoice_number" disabled>
                            </div>
                            <div class="mcf-page-editor-column-select">
                                <label>Etat</label>
                                <select v-model="sl.state" disabled>
                                    <option value="INV_LBL_DRAFT">Brouillon</option>
                                    <option value="INV_LBL_RUNNING">En cours</option>
                                    <option value="INV_LBL_SOLD">Terminé</option>
                                </select>
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Date</label>
                                <input type="date" v-model="sl.invoice_date" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-select">
                                <label>Type de document</label>
                                <select v-model="sl.label" disabled>
                                    <option value="LBL_INVOICE">Facture</option>
                                    <option value="LBL_ADVANCE">Facture d'acompte</option>
                                    <option value="LBL_CREDIT">Avoir</option>
                                </select>
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Durée de l'offre</label>
                                <input type="text" v-model="sl.offer_period" :disabled="is_disabled">
                            </div>
                        </div>
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Conditions de règlement</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-select">
                                <label>Type de règlement</label>
                                <select v-model="sl.terms_condition" :disabled="is_disabled">
                                    <option v-for="p of sl.lists.paymentstypes" :key="p.label" :value="p.label">{{p.label}}</option>
                                </select>
                            </div>
                            <div class="mcf-page-editor-column-select" v-if="sl.terms_delay=='TERM_RECEIPT'">
                                <label>Délais</label>
                                <select v-model="sl.terms_delay" :disabled="is_disabled">
                                    <option value="TERM_NETDAY">jours nets</option>
                                    <option value="TERM_ENDOFMONTHTO">jours fin de mois le</option>
                                    <option value="TERM_ENDOFMONTH">jours fin de mois</option>
                                    <option value="TERM_RECEIPT">à réception de facture</option>
                                </select>
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-3" v-if="sl.terms_delay!='TERM_RECEIPT'">
                            <div class="mcf-page-editor-column-text">
                                <label>Nombre de jours</label>
                                <input type="number" v-model="sl.terms_nb" placeholder="Nombre de jours" :disabled="is_disabled">
                            </div>
                            <div class="mcf-page-editor-column-select">
                                <label>Délais</label>
                                <select v-model="sl.terms_delay" :disabled="is_disabled">
                                    <option value="TERM_NETDAY">jours nets</option>
                                    <option value="TERM_ENDOFMONTHTO">jours fin de mois le</option>
                                    <option value="TERM_ENDOFMONTH">jours fin de mois</option>
                                    <option value="TERM_RECEIPT">à réception de facture</option>
                                </select>
                            </div>
                            <div class="mcf-page-editor-column-text" v-if="sl.terms_delay=='TERM_ENDOFMONTHTO'">
                                <label>Jour d'échéance</label>
                                <input type="number" v-model="sl.terms_day_due" placeholder="Jour d'échéance" :disabled="is_disabled">
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='tax1'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> {{sl.tax1_label}}</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>{{sl.tax1_label}}</label>
                                <input type="checkbox" v-model="sl.tax1_is_included" id="tax1_is_included" :disabled="is_disabled">
                                <label for="tax1_is_included"></label>
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='tax2'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> {{sl.tax2_label}}</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>{{sl.tax2_label}}</label>
                                <input type="checkbox" v-model="sl.tax2_is_included" id="tax2_is_included" :disabled="is_disabled">
                                <label for="tax2_is_included"></label>
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='tax3'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> {{sl.tax3_label}}</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>{{sl.tax3_label}}</label>
                                <input type="checkbox" v-model="sl.tax3_is_included" id="tax3_is_included" :disabled="is_disabled">
                                <label for="tax3_is_included"></label>
                            </div>
                        </div>
                    </div>
                    <div v-if="view=='note'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Commentaire</label>
                        </div>
                        <div class="mcf-page-editor-line">
                            <div class="mcf-page-editor-column-text">
                                <label>Commentaire</label>
                                <textarea type="text" v-model="sl.note" placeholder="" :disabled="is_disabled"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        account:Object,
        invoice:Object,
        view:String,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            sl: this.invoice
        };
    },
    computed: {
        is_disabled: function(){
            return (this.invoice.invoice_number!='XXXXXXXX');
        }
    },
    created() {
        this.sl.tax1_is_included = (this.sl.tax1_is_included==1);
        this.sl.tax2_is_included = (this.sl.tax2_is_included==1);
        this.sl.tax3_is_included = (this.sl.tax3_is_included==1);
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_save:function(){
            // if (!isNaN(parseFloat(this.prod.coef_margin))==false){
            //     this.prod.coef_margin = 0;
            // }
            this.save(this.sl);
        },
        set_copy_addresses: function(){
            var tmain = this;
            tmain.sl.cust_deliverycompany = tmain.sl.cust_billingcompany;
            tmain.sl.cust_deliveryaddress1 = tmain.sl.cust_billingaddress1;
            tmain.sl.cust_deliveryaddress2 = tmain.sl.cust_billingaddress2;
            tmain.sl.cust_deliveryaddress3 = tmain.sl.cust_billingaddress3;
            tmain.sl.cust_deliveryzipcode = tmain.sl.cust_billingzipcode;
            tmain.sl.cust_deliverycity = tmain.sl.cust_billingcity;
            tmain.sl.cust_deliverycountry = tmain.sl.cust_billingcountry;
            tmain.sl.cust_deliveryphone = tmain.sl.cust_billingphone;
        },
        set_copy_auto: function() {
            var tmain = this;
            tmain.sl.cust_deliverycompany = tmain.sl.cust_deliverycompany=='' ? tmain.sl.cust_billingcompany : tmain.sl.cust_deliverycompany;
            tmain.sl.cust_deliveryaddress1 = tmain.sl.cust_deliveryaddress1=='' ? tmain.sl.cust_billingaddress1: tmain.sl.cust_deliveryaddress1;
            tmain.sl.cust_deliveryaddress2 = tmain.sl.cust_deliveryaddress2=='' ? tmain.sl.cust_billingaddress2: tmain.sl.cust_deliveryaddress2;
            tmain.sl.cust_deliveryaddress3 = tmain.sl.cust_deliveryaddress3=='' ? tmain.sl.cust_billingaddress3: tmain.sl.cust_deliveryaddress3;
            tmain.sl.cust_deliveryzipcode = tmain.sl.cust_deliveryzipcode=='' ? tmain.sl.cust_billingzipcode: tmain.sl.cust_deliveryzipcode;
            tmain.sl.cust_deliverycity = tmain.sl.cust_deliverycity=='' ? tmain.sl.cust_billingcity: tmain.sl.cust_deliverycity;
            tmain.sl.cust_deliverycountry = tmain.sl.cust_deliverycountry=='' ? tmain.sl.cust_billingcountry: tmain.sl.cust_deliverycountry;
            tmain.sl.cust_deliveryphone = tmain.sl.cust_deliveryphone=='' ? tmain.sl.cust_billingphone: tmain.sl.cust_deliveryphone;
        }
    }
}
</script>